var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "close-on-content-click": false,
        bottom: "",
        left: "",
        "min-width": "300",
        "max-width": "300",
        "nudge-left": "12",
        "offset-x": "",
        transition: "slide-y-transition",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function () {
            return [
              _c(
                "v-btn",
                {
                  staticClass: "elevation-0",
                  staticStyle: { top: "96px" },
                  attrs: {
                    color: "grey",
                    dark: "",
                    fab: "",
                    fixed: "",
                    top: "",
                  },
                },
                [_c("v-icon", [_vm._v("mdi-settings")])],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-container",
            { attrs: { "grid-list-xl": "" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-center body-2 text-uppercase sidebar-filter",
                        },
                        [_vm._v("Sidebar Filters")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { attrs: { "justify-center": "" } },
                        _vm._l(_vm.colors, function (c) {
                          return _c("v-avatar", {
                            key: c,
                            class: [
                              c === _vm.color
                                ? "color-active color-" + c
                                : "color-" + c,
                            ],
                            attrs: { size: "23" },
                            on: {
                              click: function ($event) {
                                return _vm.setColor(c)
                              },
                            },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider", { staticClass: "mt-3" }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-center body-2 text-uppercase sidebar-filter",
                      },
                      [_vm._v("Images")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.images, function (img) {
                    return _c(
                      "v-col",
                      { key: img, attrs: { cols: "3" } },
                      [
                        _c("v-img", {
                          class: [_vm.image === img ? "image-active" : ""],
                          attrs: { src: img, height: "120" },
                          on: {
                            click: function ($event) {
                              return _vm.setImage(img)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-btn", { attrs: { color: "primary", block: "" } }, [
                        _vm._v(" Free Download "),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "white--text",
                          attrs: { color: "primary", block: "" },
                        },
                        [_vm._v(" Documentation ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c(
                      "div",
                      { staticClass: "text-center body-2 text-uppercase" },
                      [
                        _c("div", { staticClass: "sidebar-filter" }, [
                          _vm._v("Thank You for Sharing!"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "mr-2 v-btn-facebook",
                                attrs: {
                                  color: "indigo",
                                  dark: "",
                                  fab: "",
                                  icon: "",
                                  small: "",
                                },
                              },
                              [_c("v-icon", [_vm._v("mdi-facebook")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "v-btn-twitter",
                                attrs: {
                                  color: "cyan",
                                  dark: "",
                                  fab: "",
                                  icon: "",
                                  small: "",
                                },
                              },
                              [_c("v-icon", [_vm._v("mdi-twitter")])],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }